module.exports = __webpack_public_path__ + "static/media/google.5faf43f1.svg";